var BlogConteudoArtigo = function () {
	
	this.init = function () {
		$("#confirmation-modal .btn").click(function(e){
			e.preventDefault();
			$('#confirmation-modal .close-modal').trigger('click');
		});

		if($('#BlogPrivado').val() == "true" && $('#isMemberLogged').val() == "false"){
			$('#login-form').css('display', 'none');
			$('#esqueci-senha-form').css('display', 'none');
			$('#esqueci-senha-confirmacao').css('display', 'none');
			$('#cadastro-form').css('display', 'none');
			$('#cadastro-confirmacao').css('display', 'none');
			$('#perfil-form').css('display', 'none');
			$("#perfil-confirmacao").css("display", "none");
			$("#modal-login").css("display", "block");
			$('#modal-header').open();
		}

		if($('#isMemberLogged').val() == "true"){
			$('.btn-escrever-comentario').hide();
		}else{	
			$('#form-comentario').hide();
		}

		$('#form-comentario input[type="submit"]').click(function(e){
			e.preventDefault();
			
			var IdComponent = $('#BlogIdComponent').val();
			var Comment	= $('#form-comentario textarea').val();
			
			$('.loader').show();
			
			$.ajax({
				type: "POST",
				url: "/umbraco/surface/blog/createcomment",
				data: JSON.stringify({"IdComponent": IdComponent, "Comment": Comment}),
				dataType: "json",
				async: true,
				contentType: "application/json; charset=utf-8",
				success: function success(response) {
					$("#form-comentario").each(function () {
						this.reset();
					});

					if(response == true){	
						$("#confirmation-modal").find(".title").text("Seu comentário foi enviado com sucesso! Aguarde a avaliação do moderador para que seja publicado.");
						$("#confirmation-modal").find(".btn").text("OK");
					}else if(response == false){
						$("#confirmation-modal").find(".title").text("Ocorreu um erro, tente novamente mais tarde");
						$("#confirmation-modal").find(".btn").text("OK");
					}else if(response.length > 0){
						$("#confirmation-modal").find(".title").text(response);
						$("#confirmation-modal").find(".btn").text("OK");
					}

				},
				error: function error(e) {
					$("#confirmation-modal").find(".title").text("Ocorreu um erro, tente novamente mais tarde");
				},
				complete: function () {
					$('.loader').hide();
					$("#confirmation-modal").open();
				}
			});
		});
		
		$(".btn-comments").click(function(){
			$(".btn-comments img").toggleClass('active');
			$(".box-comentarios").slideToggle();
		});

		$('.btn-escrever-comentario').click(function(e){
			e.preventDefault();
			if($('#modal-header').find('#isMemberLogged').val() == "true"){
				$('.btn-escrever-comentario').hide();
				$('#form-comentario').show();
			}else{
				$('#login-form').css('display', 'none');
				$('#esqueci-senha-form').css('display', 'none');
				$('#esqueci-senha-confirmacao').css('display', 'none');
				$('#cadastro-form').css('display', 'none');
				$('#cadastro-confirmacao').css('display', 'none');
				$('#perfil-form').css('display', 'none');
				$("#perfil-confirmacao").css("display", "none");
				$("#modal-login").css("display", "block");
				$('#modal-header').open();
			}
			
		});
	}

	return this.init();
}
